/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { AreaOfStudyCategory, AxiomEmployeeType, BusinessTitle, CountryCode, EmployeeType, ExpandFaFilter, FocusArea, GeneralSkill, Industry, LanguageProficiency, LegalSkill, LegalTechSkill, LegalTechnicalSkillProficiency, OpportunityStageCode, PracticeAreaEnum, ProfileStatus, UserSearchesType, WorkPreferenceFilter } from "../enums";
export const userSearchSchema = z.object({
  alertActive: z.boolean(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  previousAlertResult: z.array(z.string()).nullish(),
  search: 
    z.object({
      addressCountryCode: z.nativeEnum(CountryCode).nullish(),
      addressStates: z.array(z.string()).nullish(),
      areaOfStudyCategories: 
        z.array(z.nativeEnum(AreaOfStudyCategory))
      .nullish(),
      axiomEmployeeType: 
        z.array(z.nativeEnum(AxiomEmployeeType))
      .nullish(),
      barredLocations: z.array(z.string().uuid()).nullish(),
      businessTeam: z.array(z.string()).nullish(),
      businessTitles: z.array(z.nativeEnum(BusinessTitle)).nullish(),
      compensation: 
        z.object({
          end: z.any().nullish(),
          includeEmptyValues: z.boolean().nullish(),
          name: z.string().nullish(),
          start: z.any().nullish(),
        })
      .nullish(),
      daysToSoonestEngagementEnd: z.number().nullish(),
      educationInstitution: z.string().nullish(),
      employeeType: z.array(z.nativeEnum(EmployeeType)).nullish(),
      excludeCrossFulfilled: z.boolean().nullish(),
      expandFa: z.array(z.nativeEnum(ExpandFaFilter)).nullish(),
      experienceAtClient: z.string().nullish(),
      generalSkills: z.array(z.nativeEnum(GeneralSkill)).nullish(),
      homeOfficeId: z.array(z.string().uuid()).nullish(),
      industries: z.array(z.nativeEnum(Industry)).nullish(),
      industriesMinYears: z.number().int().nullish(),
      isPriorityTalent: z.boolean().nullish(),
      isProfileShared: z.boolean().nullish(),
      languageProficiencies: 
        z.array(z.nativeEnum(LanguageProficiency))
      .nullish(),
      languages: z.array(z.string().uuid()).nullish(),
      legalSkills: z.array(z.nativeEnum(LegalSkill)).nullish(),
      legalSkillsMinYears: z.number().int().nullish(),
      legalTechnicalSkillProficiencies: 
        z.array(z.nativeEnum(LegalTechnicalSkillProficiency))
      .nullish(),
      legalTechnicalSkills: 
        z.array(z.nativeEnum(LegalTechSkill))
      .nullish(),
      ownerUserId: z.array(z.string().uuid()).nullish(),
      practiceAreas: z.array(z.nativeEnum(PracticeAreaEnum)).nullish(),
      practiceAreasAndFocusAreas: 
        z.object({
          focusAreas: z.array(z.nativeEnum(FocusArea)).nullish(),
          practiceAreas: 
            z.array(z.nativeEnum(PracticeAreaEnum))
          .nullish(),
        })
      .nullish(),
      practiceAreasMinYears: z.number().int().nullish(),
      profileStatus: z.array(z.nativeEnum(ProfileStatus)).nullish(),
      salesCloseDate: 
        z.object({
          end: z.string().date().nullish(),
          start: z.string().date().nullish(),
        })
      .nullish(),
      salesLeadId: z.array(z.string().uuid()).nullish(),
      search: z.string().nullish(),
      stageCode: z.array(z.nativeEnum(OpportunityStageCode)).nullish(),
      tags: z.array(z.string().uuid()).nullish(),
      weeklyAvailability: 
        z.object({
          end: z.any().nullish(),
          includeEmptyValues: z.boolean().nullish(),
          name: z.string().nullish(),
          start: z.any().nullish(),
        })
      .nullish(),
      workPreferences: 
        z.array(z.nativeEnum(WorkPreferenceFilter))
      .nullish(),
      yearsOfExperience: 
        z.object({
          end: z.any().nullish(),
          includeEmptyValues: z.boolean().nullish(),
          name: z.string().nullish(),
          start: z.any().nullish(),
        })
      .nullish(),
    })
  .nullish(),
  type: z.nativeEnum(UserSearchesType).nullish(),
  updatedAt: z.string().datetime().nullish(),
  userId: z.string().uuid().nullish(),
});

export type UserSearch = z.infer<typeof userSearchSchema>;
